import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { Vue3Mq } from "vue3-mq";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "../scss/theme.scss";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker.register("/service-worker.js").then(
      function (registration) {
        // Registration was successful
        console.log("ServiceWorker registration successful with scope: ", registration.scope);
      },
      function (err) {
        // registration failed :(
        console.log("ServiceWorker registration failed: ", err);
      }
    );
  });
}

const app = createApp(App);

app.use(Vue3Mq, {
  preset: "bootstrap5",
});
app.use(router);

app.mount("#app");
